import React from 'react';
import { Box, Button } from '@mui/material';

const LifelogPromotionToolbar = ({
  selectionMode,
  selectedCount,
  isAdding,
  addFailed,
  onBeginSelection,
  onCancelSelection,
  onAddSelected,
}) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, px: 2, py: 1 }}>
    {selectionMode ? (
      <>
        <Button size="small" onClick={onCancelSelection}>Cancel selection</Button>
        <Button
          size="small"
          variant="contained"
          disabled={selectedCount < 2 || isAdding}
          onClick={onAddSelected}
        >
          {isAdding ? 'Adding…' : addFailed ? `Try adding ${selectedCount} again` : `Add ${selectedCount} to Lifelog`}
        </Button>
      </>
    ) : (
      <Button size="small" onClick={onBeginSelection}>Select messages</Button>
    )}
  </Box>
);

export default LifelogPromotionToolbar;
